import axios, {AxiosResponse} from "axios";
import {LimitedResult, MscAdresse} from "./interfaces";
import config from "./Config";


const Api = {
    findeAdresse(query: string, abortSignal: AbortSignal): Promise<AxiosResponse<LimitedResult<MscAdresse>>> {
        return axios.post(config.urls.api, {
            _class_: "FindeAdresse",
            query
        }, {
            signal: abortSignal
        }).then(result => ({
            ...result,
            data: result.data.data
        }));
    },
    aboniere(nummer: string, adressId: number, abortSignal: AbortSignal): Promise<AxiosResponse> {
        return axios.post(config.urls.api, {
            _class_: "Aboniere",
            nummer,
            adressId
        }, {
            signal: abortSignal
        })
    },
    doubleOptIn(userId: string, abortSignal: AbortSignal): Promise<AxiosResponse> {
        return axios.post(config.urls.api, {
            _class_: "BestaetigeAbo",
            id: userId
        }, {
            signal: abortSignal
        });
    },
    optOut(userId: string, abortSignal: AbortSignal): Promise<AxiosResponse> {
        return axios.post(config.urls.api, {
            _class_: "BeendeAbo",
            id: userId
        }, {
            signal: abortSignal
        });
    }
}

export default Api;
